import { erpTranslationsQuery } from "src/system/erpTranslationsQuery.ts";

export const listTranslationsQuery = ({ resource }: { resource: string }) => {
  return erpTranslationsQuery({
    resource,
    type: "list",
  });
};
